import { Button, Space, Tooltip } from "antd";
import {HasAccess} from "@permify/react-role";

const ActionMenu = ({ actions }) => (
    <Space>
        {actions.map((action, index) => (
            <Tooltip title={action.label}>
                <Button
                    type={action.danger ? "default" : "text"}
                    danger={action.danger}
                    icon={action.icon}
                    onClick={action.onClick}
                    className="!border-gray-300 hover:!border-blue-500 hover:!text-blue-500"
                />
            </Tooltip>
        ))}
    </Space>
);

export default ActionMenu;
